// Menu routes (renamed from food-cost)

const meta = { requiresAuth: true, app: "menu" };

const routes = [
  {
    path: "/menu",
    name: "MenuHome",
    component: () => import("@/views/foodcost/FoodCostHome.vue"),
    meta,
  },
  {
    path: "/menu/ingredients",
    name: "MenuIngredients",
    component: () => import("@/views/foodcost/IngredientsPage.vue"),
    meta,
  },
  {
    path: "/menu/recipes",
    name: "MenuRecipes",
    component: () => import("@/views/foodcost/RecipesPage.vue"),
    meta,
  },
  {
    path: "/menu/packaging",
    name: "MenuPackaging",
    component: () => import("@/views/foodcost/PackagingPage.vue"),
    meta,
  },
  {
    path: "/menu/categories",
    name: "MenuCategories",
    component: () => import("@/views/foodcost/CategoriesPage.vue"),
    meta,
  },
  {
    path: "/menu/combos",
    name: "MenuCombos",
    component: () => import("@/views/foodcost/CombosPage.vue"),
    meta,
  },
];

export default routes;
